import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import CyberLobbyData from 'app/Models/Content/CyberLobbyData';
import React from 'react';

export default class CyberLobby extends Page<CyberLobbyData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div className='CyberLobby'>
        <ContentArea noWrap data={mainContentArea} context={context} />
      </div>
    );
  }
}
